export class POSParameter {
  // --- Core identifiers ---
  id: number | 0;
  hotel_id: number | 0;
  outlet_id: number | 0;
  outlet_name?: string;

  // --- Branding & ticket header/footer ---
  name_in_ticket: string | "";
  is_breakdown_vat: boolean | false;
  is_send_invoice_to_tax_interface: boolean | false;
  logo_url: string | "";
  header_text_1: string | "";
  header_text_2: string | "";
  footer_text_1: string | "";
  footer_text_2: string | "";

  // --- Number series configuration ---
  sales_order_series_id?: number;
  sales_order_series_code?: string;
  sales_order_series_name?: string;

  sales_invoice_series_id?: number;
  sales_invoice_series_name?: string;
  sales_invoice_series_code?: string;
  sales_invoice_series_prefix?: string;
  sales_invoice_series_starting_number?: number;
  sales_invoice_series_last_number_used?: number;
  sales_invoice_series_num_length?: number;
  sales_invoice_series_include_year?: boolean;

  sales_credit_memo_series_id?: number;
  sales_credit_memo_series_code?: string;
  sales_credit_memo_series_name?: string;

  pos_closing_day_invoice_series_id?: number | null;
  pos_closing_day_invoice_series_code?: string;
  pos_closing_day_invoice_series_name?: string;

  pos_bir_z_counter_series_id?: number | null;
  pos_bir_z_counter_series_code?: string;
  pos_bir_z_counter_series_name?: string;

  system_name?: string | null;
  system_vat_reg_tin?: string | null;
  system_accr_no?: string | null;
  system_accr_issued_date?: string | null;
  system_accr_valid_until?: string | null;
  system_ptu_no?: string | null;
  system_ptu_issued_date?: string | null;
  system_address?: string | null;

  // --- VAT posting and regulatory numbers ---
  vat_business_posting_group_id?: number;
  vat_business_posting_group_code?: string;
  vat_business_posting_group_name?: string;

  vat_reg_no?: string;
  min_no?: string;
  sn_no?: string;
  permit_no?: string;
  accredited_no?: string;
  check_no_series_name?: string;
  receipt_no_series_name?: string;

  check_no_series_code?: string;
  receipt_no_series_code?: string;

  check_no_series_id?: number;
  receipt_no_series_id?: number;

  // --- Audit information ---
  last_modified: Date | null;
  last_modified_by: number | null;
  created: Date | null;
  created_by: number | null;
  allow_delete_sent_items: boolean;
  is_multiple_payment_grouped_by_type: boolean;
  amount_of_bill_to_print_on_processing_payment: number;
  bill_print_show_guest_payment_amount_on_cash: boolean;
  default_bill_printer_id?: number;
  /**
   * CLIENT-ONLY, never a column and never sent to the backend. Set by Print Bill Settings when the
   * cashier changes the printer field; only then does `default_bill_printer_id` override this
   * device's own head (iMin / M7). See sentec-vues posPrintBill/resolveBillPrintTarget.
   */
  bill_printer_chosen_by_cashier?: boolean;
  label_printer_id?: number;
  // --- Sticky-label printing ---
  label_print_top_margin: number | 0;
  label_print_left_margin: number | 0;
  label_print_right_margin: number | 0;
  label_print_bottom_margin: number | 0;
  label_print_paper_width: number | 0;
  label_print_paper_height: number | 0;
  label_print_font_size: number | 0;
  bill_print_hide_hotel_name: boolean;
  bill_print_font_size: number | 0;
  bill_print_top_margin: number | 0;
  bill_print_left_margin: number | 0;
  bill_print_right_margin: number | 0;
  bill_print_bottom_margin: number | 0;
  bill_print_line_offset: number | 0;
  bill_print_is_wrap_text: boolean;
  bill_print_font: string;
  bill_print_paper_width: number | undefined | string | null;
  bill_print_paper_height: number | undefined | string | null;
  bill_print_all_bold: boolean;
  bill_print_logo_width: number;
  show_manual_or_number: boolean | false;
  // --- Send-order / kitchen printing ---
  send_order_print_font_size: number;
  send_order_print_top_margin: number;
  send_order_print_left_margin: number;
  send_order_print_right_margin: number;
  send_order_print_bottom_margin: number;
  send_order_print_line_offset: number;
  send_order_print_paper_width: number | undefined | string | null;
  send_order_print_paper_height: number | undefined | string | null;
  send_order_print_font: string;
  send_order_print_all_bold: boolean;
  is_split_invoice: boolean;
  is_enable_exempt_vat?: boolean;

  client_composition_id?: number | 0;
  agency_group_name?: string;
  agency_name?: string;
  client_name?: string;
  inventory_warehouse_location_id?: number | 0;
  inventory_warehouse_location_name?: string | 0;
  max_preview_bill_print_count?: number | 0;
  price_setup_type_id?: number | 0;
  price_setup_type_name?: string | null;
  show_guest_name_in_send_order: boolean;
  is_card_number_not_mandatory?: boolean;
  is_card_name_not_mandatory?: boolean;
  is_card_trace_no_not_mandatory?: boolean;
  is_delete_sent_order_reason_not_mandatory?: boolean;
  is_cancel_order_reason_not_mandatory?: boolean;
  is_print_cancel_order_doc?: boolean;
  is_print_bill_on_quick_order?: boolean;
  is_send_food_on_quick_order?: boolean;
  is_send_beverage_on_quick_order?: boolean;
  is_send_others_on_quick_order?: boolean;
  is_send_tobacco_on_quick_order?: boolean;
  is_hide_table_number_in_table_list?: boolean;
  outlet_key_card_config_item_id?: number;
  bill_layout_id?: number;

  is_preview_show_guest_signature_field: boolean;
  is_preview_show_room_no_field: boolean;
  is_preview_show_tip_field: boolean;

  allow_zero_cover: boolean;

  amount_decimal_places?: number;
  package_group_name?: string;
  package_sort_order_no?: number;
  show_package_order_detail_price?: boolean;
  allow_package_member_discount?: boolean;

  guest_id?: number;
  guest_name?: string;

  ask_pin_on_delete_or_void?: boolean;

  // --- Layout C footer statements / PH compliance ---
  layout_c_sales_invoice_statement?: string | null;

  use_menu_tags: boolean;

  // --- Layout Common D (Cambodian) overrides ---
  hide_tax_in_layout_common_d?: boolean;
  bill_show_room_name?: boolean;
  // --- Bill print: combine every non-Service-Charge tax line into one (PMS-1170, all layouts) ---
  bill_print_combine_tax_lines?: boolean;
  // --- EDC Machine Integration ---
  is_edc_enabled?: boolean;
  /** "auto" = always route to EDC, "prompt" = let cashier choose EDC vs manual credit */
  edc_mode?: string;
  /** Sentec Agent base URL, e.g. "http://localhost:5001" */
  edc_agent_url?: string;
  /** EDC vendor identifier, e.g. "GHL" */
  edc_vendor?: string;
  /** Sentec Agent auth token for EDC — overrides the pos.agent token when set */
  edc_agent_token?: string;
  /** COM/serial port the EDC terminal is connected to, e.g. "COM3" */
  edc_com_port?: string;
  /** When true, cashiers can select a subset of items to pay separately; selected items are moved to a new order and paid atomically */
  split_bill_by_item?: boolean | null;
  /** PMS-553: when true, the outlet captures customer tips (Cash/Card tenders) on the Payment dialog. Default false — feature is dark until the outlet opts in. */
  enable_tips?: boolean | null;
}
